import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082", // Substitua pelo URL do seu backend
// });
/**
 * Movimentação de Estoque — POC.
 *
 * Seguindo o mesmo padrão de stockItemService.js (branch feature/poc-estoque):
 * `index`/`show` retornam dados MOCK em memória (portados de
 * lovable-material-hub/data/estoqueMock.ts, com enums já em inglês maiúsculo);
 * as chamadas REST reais ficam escritas e comentadas, prontas para ligar quando
 * o backend confirmar os endpoints. `save` e `request-deletion` tentam o REST
 * real. Demais chamadas (check NF / parse XML-PDF / DANFE) são stubs.
 */

// Mock de movimentos — PT (hub) já mapeado para os enums em inglês da spec.
// const MOCK_STOCK_MOVEMENTS = [
//   {
//     id: "mv1",
//     type: "ENTRY",
//     entryOrigin: "PURCHASE",
//     stockItemId: "ie1",
//     variantId: "p1",
//     variantName: "Premix Campo - 30kg",
//     batchId: "LT2024-01",
//     batchName: "LT2024-01",
//     batchNumber: "LT2024-01",
//     quantity: 120,
//     unitCost: 3.5,
//     status: "COMPLETED",
//     nfReference: "NF-2024-0451",
//     userId: "u1",
//     userName: "João Silva",
//     createdAt: "2024-07-10T09:30:00",
//   },
//   {
//     id: "mv2",
//     type: "ENTRY",
//     entryOrigin: "PURCHASE",
//     stockItemId: "ie1",
//     variantId: "p2",
//     batch: "LT2024-03",
//     quantity: 80,
//     unitCost: 3.75,
//     status: "COMPLETED",
//     nfReference: "NF-2024-0523",
//     creationUser: "João Silva",
//     creationDate: "2024-08-15T10:00:00",
//   },
//   {
//     id: "mv3",
//     type: "ENTRY",
//     entryOrigin: "PURCHASE",
//     stockItemId: "ie2",
//     variantId: "p3",
//     batch: "LT2024-05",
//     quantity: 2500,
//     unitCost: 2.1,
//     status: "COMPLETED",
//     nfReference: "NF-2024-0612",
//     creationUser: "Maria Santos",
//     creationDate: "2024-10-05T14:15:00",
//   },
//   {
//     id: "mv4",
//     type: "EXIT",
//     exitOrigin: "WITHDRAWAL",
//     stockItemId: "ie1",
//     variantId: "p1",
//     quantity: 30,
//     status: "COMPLETED",
//     creationUser: "Pedro Costa",
//     creationDate: "2025-01-20T08:00:00",
//     requestUser: "Dr. Ana Veterinária",
//     requestDate: "2025-01-19T16:00:00",
//     observations: "Vacinação lote bovino 42",
//   },
//   {
//     id: "mv5",
//     type: "ENTRY",
//     entryOrigin: "PURCHASE",
//     stockItemId: "ie6",
//     variantId: "p7",
//     batch: "LT2025-02",
//     quantity: 5000,
//     unitCost: 1.8,
//     status: "PENDING",
//     creationUser: "Maria Santos",
//     creationDate: "2025-02-20T11:00:00",
//     observations: "Aguardando NF do fornecedor Nutripura",
//   },
//   {
//     id: "mv6",
//     type: "EXIT",
//     exitOrigin: "LOSS",
//     stockItemId: "ie3",
//     variantId: "p4",
//     quantity: 15,
//     status: "PENDING",
//     creationUser: "Pedro Costa",
//     creationDate: "2025-02-28T09:30:00",
//     observations: "Frasco danificado durante transporte interno",
//   },
//   {
//     id: "mv7",
//     type: "ENTRY",
//     entryOrigin: "PURCHASE",
//     stockItemId: "ie7",
//     quantity: 3200,
//     unitCost: 5.89,
//     status: "COMPLETED",
//     nfReference: "NF-2025-0089",
//     creationUser: "João Silva",
//     creationDate: "2025-01-10T13:45:00",
//   },
//   {
//     id: "mv8",
//     type: "EXIT",
//     exitOrigin: "WITHDRAWAL",
//     stockItemId: "ie7",
//     quantity: 450,
//     status: "COMPLETED",
//     creationUser: "Pedro Costa",
//     creationDate: "2025-02-15T07:00:00",
//     requestUser: "Carlos Motorista",
//     requestDate: "2025-02-14T17:00:00",
//     observations: "Abastecimento frota semanal",
//   },
// ];

export function callStockMovementIndex(payload) {
  // const { page = 0, size = 15 } = payload;
  // const start = page * size;
  // const results = MOCK_STOCK_MOVEMENTS.slice(start, start + size);
  // return Promise.resolve({
  //   data: { results, total: MOCK_STOCK_MOVEMENTS.length },
  // });

  const { groupId, farmId, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/movements`,
    getHeaders(false, signal),
  );
}

export function callStockMovementShow(payload) {
  // const { id } = payload;
  // const found = MOCK_STOCK_MOVEMENTS.find((mov) => mov.id === id) ?? null;
  // return Promise.resolve({ data: found });

  const { groupId, farmId, id, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/movements/${id}`,
    getHeaders(false, signal),
  );
}

/**
 * Salva o movimento. O backend deve, numa única transação, persistir o
 * movimento + atualizar o saldo do item + gerar o lançamento contábil, além de
 * definir o `status` resultante (PENDING/COMPLETED). O front apenas envia.
 */
export function callStockMovementSave(payload) {
  const { groupId, farmId, movement, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/stock/movements`,
    movement,
    getHeaders(false, signal),
  );
}

/**
 * Solicita exclusão do movimento. O backend cria o registro de auditoria e
 * marca o movimento como AUDIT (bloqueado até aprovação por segundo usuário).
 */
export function callStockMovementRequestDelete(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.delete(
    `/bovexo/${groupId}/farms/${farmId}/stock/movements/${id}`,
    getHeaders(false, signal),
  );
}

/**
 * Verifica se a NF já foi registrada. Stub (sempre não-duplicada) até o backend
 * disponibilizar o endpoint. Retorna o mesmo shape esperado pela UI.
 */
export function callStockMovementCheckDuplicateNf() {
  return Promise.resolve({
    data: { isDuplicate: false, allCovered: false, missingNfProducts: [] },
  });

  // const { groupId, farmId, nfNumber, cnpj, signal } = payload;
  // return apiFarms.get(
  //   `/bovexo/${groupId}/farms/${farmId}/stock/movements/check-nf`,
  //   { params: { nfNumber, cnpj }, ...getHeaders(false, signal) }
  // );
}

/** Parse de XML de NF-e — stub. Implementação real fica no backend. */
export function callParseNfeXml() {
  return Promise.reject(
    new Error("Parse de XML de NF-e ainda não disponível no backend."),
  );

  // const { groupId, farmId, file, signal } = payload;
  // const formData = new FormData();
  // formData.append("file", file);
  // return apiFarms.post(
  //   `/bovexo/${groupId}/farms/${farmId}/stock/nfe/parse-xml`,
  //   formData,
  //   getHeaders(true, signal)
  // );
}

/** Parse de PDF de NF — stub. Implementação real fica no backend. */
export function callParseNfPdf() {
  return Promise.reject(
    new Error("Parse de PDF de NF ainda não disponível no backend."),
  );

  // const { groupId, farmId, file, signal } = payload;
  // const formData = new FormData();
  // formData.append("file", file);
  // return apiFarms.post(
  //   `/bovexo/${groupId}/farms/${farmId}/stock/nfe/parse-pdf`,
  //   formData,
  //   getHeaders(true, signal)
  // );
}
